import type { ApolloError } from "@apollo/client";

/** What a record page shows before it has its record. */
export enum PageLoadStatus {
  LOADING = "LOADING",
  NOT_FOUND = "NOT_FOUND",
  FAILED = "FAILED",
}

// getJob/getInvoice are non-null and resolve a missing record to null, and a malformed id fails the ObjectId cast.
const NOT_FOUND_MESSAGES = [/Cannot return null for non-nullable field/i, /Cast to ObjectId failed/i];

export const isNotFoundError = (error?: ApolloError | null): boolean =>
  !!error &&
  !error.networkError &&
  (error.graphQLErrors ?? []).some(({ message }) => NOT_FOUND_MESSAGES.some((pattern) => pattern.test(message ?? "")));

/** For a page with no record yet: still loading until the query errors. */
export const pageLoadStatusFor = (error?: ApolloError | null): PageLoadStatus => {
  if (!error) return PageLoadStatus.LOADING;
  return isNotFoundError(error) ? PageLoadStatus.NOT_FOUND : PageLoadStatus.FAILED;
};
